import { useQuery } from '@tanstack/react-query';
import * as Routes from 'modules/routes';
import axios from 'axios';
import { LibraryTagValues } from '../types';

type LibraryTagValuesTypes = {
  isEnabled: boolean,
  libraryTagId: number,
  programId: number,
  tagId: number;
};

const useLibraryTagValues = ({ isEnabled, libraryTagId, programId, tagId }: LibraryTagValuesTypes) => {
  const path = Routes.plato_api_library_tag_values_tags_path({
    library_tag_id: libraryTagId,
    program_id: programId,
    tag_id: tagId,
  });

  // Unlike the unit/lesson hooks this lets a failed fetch reach react-query's isError, so the row
  // can say the load failed instead of "no content".
  const query = useQuery(['library_tag_content', programId, libraryTagId, tagId], () => (
    axios.get<LibraryTagValues>(path).then(res => res.data)
  ), { enabled: isEnabled, staleTime: Infinity });

  return { ...query, data: query.data || {} as LibraryTagValues };
};

export default useLibraryTagValues;
